import React from 'react'
import styled from 'styled-components'






function Section1() {


    return (
        <Container>
            <h2>المظفر في الصحافة</h2>
            <Grid>
            <Wrap>
            
            <img src="/images/section11.png" alt="المحامي محمد المظفر يساعد مواطنة لاسترجاع حقها بعد خطأ طبي في ايران" />
            <Content>
            <h3>خطأ طبي لمواطنة في إيران</h3>
            <p>المحامي محمد المظفر : تواصلت مع الدكتور "عبدالعزيز الرشيد" لإجراء عملية للشابة الكويتية المتضررة من عملية التجميل في إيران</p>
            </Content>
            </Wrap>

            <Wrap>
            <img src="/images/section1-2.png" alt="المحامي محمد المظفر ينصح بمعالجة المدمنين بدل من عقابهم" />
            <Content>
            <h3>علاج الإدمان</h3>
            <p> المحامي محمد المظفر: اطيب ناسم اهما المدمنين اذا ولدك مدمن او اخوك او صديقك مدمن لا تبتعد عنه حط ايدك بإيده و عالجه تراهم ناس لان قاعدين يضرون نفسهم مو قاعدين يضرون غيرهم</p>
            </Content>
            </Wrap>

            <Wrap>
            <img src="/images/section1-33.png" alt="تحصل المحامي محمد المظفر على حكمين لصالح موكلينه في الكويت و الامارات" />
            <Content>
            <h3>حكمين في يوم</h3>
            <p> المحامي محمد المظفر: الحمدلله اليوم كسبت حكمين بالكويت و الامارات .. الاول صدر حكم بأحقية المدعي من إستكمال دراسته الجمع بين الوظيفة و الدراسة، الحكم الثاني إلغاء الابعاد و براءه من باقي التهم لصالح موكلي الحمدالله </p>
            </Content>
            </Wrap>

            <Wrap>
            <img src="/images/section1-4.png"  alt="كتاب محامي كوميدي للمحامي محمد المظفر يكتسح معرض الشارقة للكتاب"/>
            <Content>
            <h3>محامي كوميدي يفوق التوقعات </h3>
            <p> من بين مليون عنوان في معرض الكتاب في الشارقة يتميز كتاب " محامي كوميدي " للمحامي محمد المظفر و يسعى الزوار إلى على اكثر من ١٠٠٠ دار مشاركة في المعرض، الكتاب نزل المعرض اليوم و نصف الطبعة الأولى خلصت</p>
            </Content>
            </Wrap>

            <Wrap>
            <img src="/images/section100.jpeg" alt="المحامي محمد المظفر يحضر مع المتهم بقضية القتل في ابوفطيرة و يكشف ان المتعم ليس له علاقة بالقتل ليتم استبعاده عن القضية" />
            <Content>
            <h3>متهم بقتل عامل توصيل طلبات </h3>
            <p> بعد انتشار خبر الجريمة في الصحف و وسائل التواصل الإجتماعي تدخل المحامي محمد المظفر للدافع عن الجاني حسب الادعاءات التي تخالف الحقيقة و ساهم هذا التدخل بإستباعد التهمة عن المتهم و حصوله على صك البراءة قبل التوجه للمحكمة</p>
            </Content>
            </Wrap>
            </Grid>
            
        </Container>
    )
}

export default Section1

const Container = styled.div`

`

const Wrap = styled.div`
    border-radius: 10px;

   
    text-align: justify;    cursor: pointer;
    overflow: hidden;
    border: 3px solid rgba(249, 249, 249, 0.1);
    box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
    rgb(0 0 0 / 73%) 0px 16px 10px -10px;
    transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
    
    img{
        width: 100%;
        height: 200px;
        object-fit: cover;
    }
    &:hover {
        box-shadow: rgb(0 0 0 / 80%) 0px 40px 58px -16px,
        rgb(0 0 0 / 72%) 0px 30px 22px -10px;
        transform: scale(1.05);
        border-color: rgba(249, 249, 249, 0.8);
    }
`

const Content = styled.div`
padding: 20px;
`

const Grid = styled.div`
display: grid;
grid-gap: 25px;
grid-template-columns: repeat(4, minmax(0, 1fr));

@media only screen and (min-width: 480px) and (max-width: 768px) {
   
    grid-template-columns: repeat(1, minmax(0, 1fr));
    
 
  }
@media only screen and (max-width: 479px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
    
  }


`